'use client';
import Image from 'next/image';
import { PortableText } from '@portabletext/react';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import CardSlide2Parts from '@/components/CardSlide2Parts';
import React from 'react';
import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';

type Content2PartsSlideAndImageProps = {
  anchor?: string;
  image?: any;
  firstContent?:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  secondContent?:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  thirdContent?:
    | (PortableTextBlock | ArbitraryTypedObject)
    | (PortableTextBlock | ArbitraryTypedObject)[];
  cardSlidesTitle?: string;
  title?: string;
  cardSlides2Parts?: any;
};
const Content2PartsSlideAndImage = ({
  anchor,
  image,
  title,
  firstContent,
  secondContent,
  thirdContent,
  cardSlides2Parts,
  cardSlidesTitle,
}: Content2PartsSlideAndImageProps) => {
  return (
    <section id={anchor} className="max-w-8xl mx-auto mt-12 scroll-mt-[150px]">
      <BlurInH2>{title}</BlurInH2>
      <div className="w-full [&>p]:mb-4 [&>h2]:text-4xl [&>h2]:mb-8 [&>p]:my-6 [&>h5]:font-bold [&>h5]:text-3xl [&>ul]:list-disc [&>ul>li]:pb-2 [&>ul>li]:ml-4">
        {firstContent && <PortableText value={firstContent} />}
      </div>
      <p className="text-black drop-shadow-sm text-lg font-medium pb-4 xl:max-w-[60%]">
        {cardSlidesTitle}
      </p>
      <div className="mt-4">
        <CardSlide2Parts cardSlides={cardSlides2Parts} />
      </div>

      <div className="w-full [&>p]:mb-4 [&>h2]:text-4xl [&>h2]:mb-8 [&>p]:my-6 [&>h5]:font-bold [&>h5]:text-3xl [&>ul]:list-disc [&>ul>li]:pb-2 [&>ul>li]:ml-4">
        {secondContent && <PortableText value={secondContent} />}
      </div>
      {thirdContent && image && (
        <div className="flex justify-between mb-2 gap-4 mt-4">
          <div className="w-full lg:w-1/2 [&>p]:mb-4 [&>h2]:text-4xl [&>h2]:mb-8 [&>p]:my-6 [&>h5]:font-bold [&>h5]:text-3xl [&>ul]:list-disc [&>ul>li]:pb-2 [&>ul>li]:ml-4">
            {thirdContent && <PortableText value={thirdContent} />}
          </div>
          {image && (
            <div className="w-full lg:w-1/2 mt-6">
              <Image
                src={getSanityImageUrl(image)}
                alt="Image"
                className="object-cover"
                loading="lazy"
                width={1000}
                height={2000}
              />
            </div>
          )}
        </div>
      )}
    </section>
  );
};
export default Content2PartsSlideAndImage;
